import { Player } from "./types";

export const PLAYERS: Player[] = [
  { name: "Bryce King", gender: "male" },
  {
    name: "Cameron Moreau",
    gender: "male",
    imageUrl:
      "https://ca.slack-edge.com/T04RRS8MHHU-U04S0UCAN3E-2596481095a6-192",
  },
  {
    name: "Colleen Barbieri",
    gender: "female",
    imageUrl:
      "https://ca.slack-edge.com/T04RRS8MHHU-U04S8F28Y4W-dc0e95940bd5-192",
  },
  {
    name: "Colin Quinn",
    gender: "male",
    imageUrl:
      "https://ca.slack-edge.com/T04RRS8MHHU-U04SG5K9HJQ-dea36f1d3b21-192",
  },
  {
    name: "David Sommers",
    gender: "male",
    imageUrl:
      "https://ca.slack-edge.com/T04RRS8MHHU-U04SVUCHWF5-98ecb60b6a13-192",
  },
  { name: "Eliza Barrow", gender: "female" },
  { name: "Lauren Sarchet", gender: "female" },
  { name: "Madison Welkener", gender: "female" },
  {
    name: "Sam Frederes",
    gender: "male",
    imageUrl:
      "https://ca.slack-edge.com/T04RRS8MHHU-U04SNPJUSMR-02f2f2993518-192",
  },
  {
    name: "Shayna Kisin",
    gender: "female",
    imageUrl:
      "https://ca.slack-edge.com/T04RRS8MHHU-U04S6ULTL5U-44a71c873f06-192",
  },
  {
    name: "Vivianne Lamarche",
    gender: "female",
    imageUrl:
      "https://ca.slack-edge.com/T04RRS8MHHU-U04SNF4C6TD-6d4d86b3c448-192",
  },
  {
    name: "Mary Elliott",
    gender: "female",
    imageUrl:
      "https://ca.slack-edge.com/T04RRS8MHHU-U04S7DLCK5L-8c1778e30dda-192",
  },
  { name: "Zack Guerra", gender: "male" },
  { name: "William Brinkmeyer", gender: "male" },
  { name: "Mike Fennema", gender: "male" },
  { name: "Matt Mortillaro", gender: "male" },
  {
    name: "Lion Hoffmann",
    gender: "male",
    imageUrl:
      "https://ca.slack-edge.com/T04RRS8MHHU-U04SDNYH4SF-456e2b176982-192",
  },
  { name: "Nolan McDaniel", gender: "male" },
  { name: "David Fredmonski", gender: "male" },
];

export const POSITIONS = [
  "Pitcher",
  "Catcher",
  "1st Base",
  "2nd Base",
  "3rd Base",
  "Left Field",
  "Right Field",
  "Short Stop",
  "Center Field",
  "Left Center",
  "Right Center",
];
